import React, { PropTypes } from 'react';
import { Icon } from 'native-base';

import { StyleSheet, Text, View, TouchableHighlight } from 'react-native';
import Alert from './alert';

class Button extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	onPress = () => {
		const { onPress, title } = this.props;
		if (onPress) {
			onPress(title);
		}
	};
	render() {
		return (
			<TouchableHighlight onPress={this.onPress} style={[styles.container, this.props.style]} underlayColor={this.props.underlayColor || '#d1d1d1'}>
				<Text style={[styles.title, this.props.titleStyle]}>{this.props.title}</Text>
			</TouchableHighlight>
		);
	}
}

export default class Calculator extends React.Component {
	constructor(props) {
		super(props);
		if (__DEV__) console.log('got ', this.props.initVal);
		this.state = {
			result: parseFloat(this.props.initVal),
			formula: ''
		};
		this.onPressOperatorOrNumber = this.onPressOperatorOrNumber.bind(this);
	}
	onPressOperatorOrNumber = symbol => {
		if (symbol === '×') {
			symbol = '*';
		}
		this.setState({
			formula: this.state.formula + symbol
		});
	};
	onPressSubmitResult = () => {
		try {
			this.setState({
				result: eval(this.state.formula) || 0
			});
		} catch (e) {
			Alert.alert('Input wrong.');
		}
	};
	backspaceOperator = () => {
		this.setState({
			formula: this.state.formula.slice(0, this.state.formula.length - 1)
		});
	};
	onPressACButton = () => {
		this.setState({ formula: '', result: 0 });
	};
	render() {
		return (
			<View style={{ flex: 1, marginVertical: '10%', marginHorizontal: '5%' }}>
				<View style={{ backgroundColor: '#282828', flex: 1 }}>
					<View style={{ flex: 1, justifyContent: 'flex-end', alignItems: 'center', flexDirection: 'row' }}>
						<Text style={{ position: 'absolute', bottom: 5, right: 10, color: '#FFF' }}>{this.props.label}</Text>
						<Text style={[styles.resultText, { fontSize: 60 - this.state.result.toString().length }]}>{this.state.result.toFixed(2)}</Text>
						<Icon name={'return-right'} style={styles.iconStyle} size={40} onPress={() => this.props.onSave(this.state.result)} />
					</View>
				</View>
				<View style={{ flex: 7, flexDirection: 'column', justifyContent: 'flex-end', backgroundColor: '#bfbfbf' }}>
					<View style={{ flex: 0.6, backgroundColor: '#494949' }}>
						<View style={{ flex: 1, alignItems: 'center', flexDirection: 'row' }}>
							<Text style={styles.formulaText}>{this.state.formula}</Text>
							<Icon name={'backspace'} style={styles.iconStyle} size={40} onPress={this.backspaceOperator} />
						</View>
					</View>
					<View style={styles.row}>
						<Button style={styles.ACbutton} titleStyle={styles.titleOperationStyle} onPress={this.onPressACButton} title="C" />
						<Button style={styles.operation} titleStyle={styles.titleOperationStyle} onPress={this.onPressOperatorOrNumber} title="/" />
					</View>
					<View style={styles.row}>
						<Button style={styles.buttonNumber} onPress={this.onPressOperatorOrNumber} title="1" />
						<Button style={styles.buttonNumber} onPress={this.onPressOperatorOrNumber} title="2" />
						<Button style={styles.buttonNumber} onPress={this.onPressOperatorOrNumber} title="3" />
						<Button style={styles.operation} titleStyle={styles.titleOperationStyle} onPress={this.onPressOperatorOrNumber} title="×" />
					</View>
					<View style={styles.row}>
						<Button style={styles.buttonNumber} onPress={this.onPressOperatorOrNumber} title="4" />
						<Button style={styles.buttonNumber} onPress={this.onPressOperatorOrNumber} title="5" />
						<Button style={styles.buttonNumber} onPress={this.onPressOperatorOrNumber} title="6" />
						<Button style={styles.operation} titleStyle={styles.titleOperationStyle} onPress={this.onPressOperatorOrNumber} title="-" />
					</View>
					<View style={styles.row}>
						<Button style={styles.buttonNumber} onPress={this.onPressOperatorOrNumber} title="7" />
						<Button style={styles.buttonNumber} onPress={this.onPressOperatorOrNumber} title="8" />
						<Button style={styles.buttonNumber} onPress={this.onPressOperatorOrNumber} title="9" />
						<Button style={styles.operation} titleStyle={styles.titleOperationStyle} onPress={this.onPressOperatorOrNumber} title="+" />
					</View>
					<View style={styles.row}>
						<Button style={styles.buttonNumber} onPress={this.onPressOperatorOrNumber} title="0" />
						<Button style={styles.buttonNumber} onPress={this.onPressOperatorOrNumber} title="00" />
						<Button style={styles.buttonNumber} onPress={this.onPressOperatorOrNumber} title="." />
						<Button style={styles.equalButton} titleStyle={styles.titleOperationStyle} onPress={this.onPressSubmitResult} title="=" />
					</View>
				</View>
			</View>
		);
	}
}

const styles = StyleSheet.create({
	component: {
		flex: 1,
		flexDirection: 'column'
	},
	ACbutton: {
		flex: 3,
		backgroundColor: '#b89a42'
		//height:75,
	},
	buttonNumber: {
		flex: 1
		//height:75,
		//backgroundColor: '#bfbfbf'
	},
	operation: {
		backgroundColor: '#295670',
		//height:75,
		flex: 1
	},
	textButton: {
		color: 'black'
	},
	formulaText: {
		flex: 1,
		color: 'white',
		textAlign: 'right',
		fontSize: 30,
		marginRight: 16
	},
	iconStyle: {
		color: 'white',
		marginLeft: 16,
		marginRight: 8
	},

	resultText: {
		color: 'white',
		textAlign: 'right',
		fontSize: 60,
		marginRight: 16
	},
	titleOperationStyle: {
		color: 'white'
	},
	row: {
		flexDirection: 'row',
		flex: 1,
		justifyContent: 'space-around',
		backgroundColor: '#bfbfbf'
	},
	equalButton: {
		backgroundColor: '#438eb9',
		flex: 1
		//height:75,
	},
	container: {
		alignItems: 'center',
		justifyContent: 'center'
	},
	title: {
		fontSize: 25
	}
});
